import GetEventCheckoutByIdRequestModelBase from '../_generated/modelBases/get-event-checkout-by-id-request-model-base';

export default class GetEventCheckoutByIdRequestModel extends GetEventCheckoutByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
